export const depense = {
  name: "Expenses",
  title_create: "Create an Expense",
  toast_success: "Expense saved successfully!",
  toast_error: "Error while saving the expense!",
  form: {
    supplier: "Supplier",
    select_supplier: "Select a supplier",
    date: "Date",
    dateCreation: "Creation date",
    invoice_number: "Invoice number",
    description: "Description",
    submit: "Save the expense",
    justificatif: "Supporting document",
    error_required: "This field is required",
    title: "Update expense",
    update_submit: "Confirm",
    invoice_input_type: "Invoice input type",
    select_existing_invoice: "Select existing invoice",
    import_pdf: "Import PDF",
    import_image: "Import image",
    select_pdf_file: "Select PDF file",
    image_upload_coming_soon: "Image upload coming soon",
    pdf_preview: "PDF Preview",
    extracted_data: "Extracted data",
    error_pdf_only: "Only PDF files are accepted",
    error_processing_pdf: "Error processing PDF",
    error_loading_pdf: "Error loading PDF",
    pdf_processed_success: "PDF processed successfully",
  },
  table: {
    title: "Purchased Products",
    name: "Name",
    quantity: "Quantity",
    price_ht: "Price (Excl. Tax)",
    tva: "VAT (%)",
    description: "Description",
    total: "Total (Incl. Tax)",
    action: "Action",
    add_product: "Add a product",
    invoice_number: "Invoice num",
    createdBy: "Created by",
  },
  total: {
    ht: "Total Excl. Tax",
    tva: "Total VAT",
    ttc: "Total Incl. Tax",
  },
  header_title: "Expenses",
};
